// removed by extract-text-webpack-plugin
module.exports = {"MessageInputsWrapper":"MessageInputsWrapper---25ibo"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/settings/ChatWidget/components/WelcomeMessage/components/MessageInputs/style.styl
// module id = qo/O
// module chunks = 89